<template>
  <VanPopup
    :show="show"
    @update:show="emit('update:show', $event)"
    class="w-[350px] py-10"
    position="center"
    round
  >
    <div class="flex flex-col items-center justify-center w-full h-full gap-4">
      <div class="flex flex-col items-center justify-center gap-2">
        <div class="text-lg font-bold">
          {{ $t("collection.addContent") }}
        </div>
      </div>
      <div class="flex flex-col gap-2">
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="clickAddMate"
        >
          <i class="iconify mingcute--user-follow-line"></i>
          {{ $t("collection.addCreator") }}
        </button>
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="showSelectMoment = true"
        >
          <i class="iconfont icon-moment"></i>
          {{ $t("collection.addMoment") }}
        </button>
        <button
          class="w-60 btn rounded btn-sm btn-primary"
          @click="showSelectStorybook = true"
        >
          <i class="iconfont icon-story1"></i>
          {{ $t("collection.addStory") }}
        </button>
        <!-- <button
            class="w-60 btn rounded btn-sm btn-primary"
            @click="showSelectGame = true"
          >
            <i class="iconfont icon-script-game"></i>
            {{ $t("collection.addGame") }}
          </button> -->
        <button
          class="btn w-60 rounded btn-sm"
          @click="emit('update:show', false)"
        >
          {{ $t("Buttons.close") }}
        </button>
      </div>
    </div>
  </VanPopup>
  <ModalSelectMoment
    v-model:show="showSelectMoment"
    :collection-id="collectionId"
    @selected="emit('selected', Object.keys($event).map(Number), 'moment')"
  />
  <ModalSelectStorybook
    v-model:show="showSelectStorybook"
    :exclude="excludeStorybookIds"
    @selected="emit('selected', $event, 'storyBook')"
  />

  <!-- <ModalSelectGame
    v-model:show="showSelectGame"
    :exclude="excludeGameIds"
    @selected="emit('selected', $event, 'game')"
  /> -->
</template>

<script lang="ts" setup>
import { ref } from "vue";
import { Mate, SelectEntityType, StoryBook } from "@/types/entity";
import { useUI } from "@/stores/ui";

const props = defineProps<{
  show: boolean;
  collectionId?: number;
  excludeStorybookIds?: number[];
  excludeMomentIds?: number[];
  excludeMateIds?: number[];
  excludeGameIds?: number[];
}>();

const emit = defineEmits<{
  (e: "update:show", show: boolean): Promise<void>;
  (
    e: "selected",
    data: number[] | StoryBook | Mate,
    type: SelectEntityType
  ): void;
}>();

const showSelectMoment = ref(false);
const showSelectStorybook = ref(false);
// const showSelectGame = ref(false);

const uiStore = useUI();
const clickAddMate = () => {
  uiStore.popMateSelector({
    mateOnly: true,
    switchMate: false,
    exclude: props.excludeMateIds || [],
    callback: (mate) => {
      emit("selected", mate, "mate");
      uiStore.showMateSelector = false;
    },
  });
};
</script>
